import { api } from 'shared/api'
import { TelegramApiSchemas } from 'shared/api/requests/telegram/schemas'

export const TelegramApi = {
  toggleChannel: api.account.createPost({
    url: '/telegram/toggle',
    schemas: TelegramApiSchemas.toggleChannel,
  }),
  updateToken: api.account.createPost({
    url: '/telegram/updateToken',
    schemas: TelegramApiSchemas.updateToken,
  }),
  getSignUpUrl: api.base.createGet({
    url: '/auth/getTelegramAuthRefUrl',
    schemas: TelegramApiSchemas.getSignUpUrl,
  }),
  getOptInUrl: api.base.createGet({
    url: '/auth/getTelegramBindingRefUrl',
    schemas: TelegramApiSchemas.getTelegramBindingRefUrl,
  }),
  getNotifyAdminOptInUrl: api.account.createGet({
    url: '/telegram/notifyAdmin/getOptInUrl',
    schemas: TelegramApiSchemas.getOptInUrl,
  }),
  notifyAdminOptOut: api.account.createPost({
    url: '/telegram/notifyAdmin/optOut',
    schemas: TelegramApiSchemas.optOut,
  }),
}
